import {Injectable} from "@angular/core";
import {StateService} from "./state.service";
import {IObjectOptions} from "../../models/new-object.models";

@Injectable({providedIn: 'root'})
export class ObjectState extends StateService<IObjectOptions> {}
